var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAttachmentPin = function SvgAttachmentPin(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 13,
    viewBox: "0 0 10 13",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4A657B",
    stroke: "#4A657B",
    strokeWidth: 0.3,
    d: "M7.046 8.863V3.715C7.046 2.225 5.682 1 4.023 1S1 2.225 1 3.715v4.983c0 1.986 1.806 3.592 4 3.592 2.212 0 4-1.606 4-3.592V3.897h-.46v4.8c0 1.755-1.586 3.18-3.54 3.18-1.935 0-3.52-1.425-3.52-3.18V3.716c0-1.258 1.142-2.285 2.543-2.285 1.401 0 2.544 1.027 2.544 2.285v5.148c0 .795-.72 1.457-1.604 1.457-.885 0-1.622-.662-1.622-1.457V3.897h-.46v4.966c0 1.027.94 1.87 2.082 1.87 1.143 0 2.083-.843 2.083-1.87z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAttachmentPin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/attachment_pin.89b7d613c13a1f1bb1f20d77602fa6bc.svg";